import React from 'react';
import styled from 'styled-components';
import { Container } from '../styles/GlobalStyles';
import { theme } from '../styles/theme';
import { Heart, Github, Globe } from 'lucide-react';

const FooterContainer = styled.footer`
  background: ${theme.colors.backgroundSecondary};
  border-top: 1px solid ${theme.colors.border};
  margin-top: auto;
`;

const FooterContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${theme.spacing[6]} 0;

  @media (max-width: ${theme.breakpoints.sm}) {
    flex-direction: column;
    gap: ${theme.spacing[4]};
    text-align: center;
  }
`;

const FooterText = styled.p`
  font-size: ${theme.typography.fontSize.sm};
  color: ${theme.colors.textSecondary};
  display: flex;
  align-items: center;
  gap: ${theme.spacing[1]};
`;

const FooterLinks = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing[4]};
`;

const FooterLink = styled.a`
  display: flex;
  align-items: center;
  gap: ${theme.spacing[1]};
  font-size: ${theme.typography.fontSize.sm};
  color: ${theme.colors.textSecondary};
  text-decoration: none;
  transition: color ${theme.transitions.fast};

  &:hover {
    color: ${theme.colors.primary};
  }
`;

const HeartIcon = styled(Heart)`
  width: 16px;
  height: 16px;
  color: ${theme.colors.error};
  fill: currentColor;
`;

const Footer: React.FC = () => {
  return (
    <FooterContainer>
      <Container>
        <FooterContent>
          <FooterText>
            Intelligent tender analysis powered by AI
          </FooterText>
          
          <FooterLinks>
            {/* <FooterLink 
              href="https://github.com/arome3/open-tender" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              <Github size={16} />
              GitHub
            </FooterLink> */}
            <FooterText>
              © 2026 Open Tender AI. All rights reserved.
            </FooterText>
          </FooterLinks>
        </FooterContent>
      </Container>
    </FooterContainer>
  );
};

export default Footer;